import cropr from "../shared/utils/cropr";
import EXIF from "exif-js/exif";
import axios from "axios";
import { gettext } from "../shared/utils/legacy";

export const getAttachmentIds = (attachmentKeys: string[]) => {
  var allAttachments = cropr.documents.models.concat(cropr.images.models),
    selectedAttachments = allAttachments.filter((a) => {
      return attachmentKeys.includes(a.get("key"));
    });
  return selectedAttachments.map((a) => a.get("id"));
};
export const convertAttachmentIds = (attachmentIds: number[]) => {
  // [1,2]-> [{'key': '1123154-123123'}, {...}]
  if (!attachmentIds) return [];
  return attachmentIds.map((objectId: number) => {
    const attachment = cropr.documents.models.concat(cropr.images.models).find((a) => {
      return a.id === objectId;
    });
    if (attachment) {
      return { key: attachment.get("key") };
    }
    return null;
  });
};
const convertDMSToDD = (degrees: number, minutes: number, seconds: number, direction: string) => {
  var dd = degrees + minutes / 60 + seconds / (60 * 60);

  if (direction === "S" || direction === "W") {
    dd = dd * -1;
  } // Don't do anything for N or E
  return dd;
};

type RequestData = {
  name: string;
  type: string;
  filetype: string;
  size: number;
  timestamp?: number;
  applier?: string;
  coordinates?: string;
  storageType: string;
};
export const handleFileUpload = (
  files: File[],
  storageType: string,
  successCallback: (doc: any, collection: Backbone.Collection) => void
) => {
  files.map((file) => {
    // @ts-ignore
    EXIF.getData(file, function () {
      // @ts-ignore
      let file = this;
      let requestData: RequestData = {
        name: file.name,
        type: file.type,
        filetype: file.type,
        size: file.size,
        storageType: storageType,
      };

      if (file.lastModified) {
        requestData["timestamp"] = file.lastModified;
      }
      if (cropr.user && cropr.user.contact_id) {
        requestData["applier"] = cropr.user.contact_id;
      }

      var url;
      if (
        ["jpeg", "image/jpeg", "jpg", "image/jpg", "png", "image/png"].includes(
          requestData.filetype
        )
      ) {
        url = "/aws/presigned-url/photos";
        var latDMS = EXIF.getTag(file, "GPSLatitude"),
          lonDMS = EXIF.getTag(file, "GPSLongitude");
        var latRef = EXIF.getTag(file, "GPSLatitudeRef"),
          lonRef = EXIF.getTag(file, "GPSLongitudeRef");
        if (latDMS && lonDMS && latDMS.length === 3 && lonDMS.length === 3 && latRef && lonRef) {
          var lat = convertDMSToDD(latDMS[0], latDMS[1], latDMS[2], latRef);
          var lon = convertDMSToDD(lonDMS[0], lonDMS[1], lonDMS[2], lonRef);
          requestData["coordinates"] = lat + "," + lon;
        }
      } else if (
        [
          "pdf",
          "application/pdf",
          "doc",
          "application/msword",
          "docx",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "xls",
          "application/vnd.ms-excel",
          "xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ].includes(requestData.filetype)
      ) {
        url = "/aws/presigned-url/documents";
      }

      if (url) {
        axios({
          method: "GET",
          responseType: "json",
          url: url,
          params: requestData,
          headers: { "X-CSRFToken": cropr.getCookie("csrftoken") },
        })
          .then(function (data) {
            uploadAndProcessFile(file, data.data, requestData, successCallback);
          })
          .catch(function (error) {
            console.warn(error);
          });
      } else {
        cropr.notify("danger", gettext("Could not recognize file type"));
      }
    });
    return null;
  });
};
const uploadAndProcessFile = (
  targetFile: File,
  data: any,
  requestData: any,
  successCallback: (doc: any, collection: Backbone.Collection) => void
) => {
  let uploadUrl = data.url;
  let storageObjectId = data.id;

  if (!targetFile) {
    console.warn("no file to upload");
    return;
  }

  var formData = new FormData();
  formData.append("file", targetFile);

  let headers: any = {
    "Content-Type": targetFile.type,
    "x-amz-meta-farm": cropr.farm.id,
    "x-amz-meta-plan": cropr.mainplan.id,
    "Access-Control-Allow-Origin": "*",
  };

  Object.keys(requestData).forEach(function (key) {
    if (["name", "timestamp", "coordinates", "applier"].includes(key)) {
      headers[`x-amz-meta-${key}`] = (requestData[key] || "").toString();
    }
  });
  axios({
    method: "PUT",
    responseType: "json",
    data: targetFile,
    url: uploadUrl,
    headers: headers,
  })
    .then(function (data) {
      var collection = uploadUrl.indexOf("images") >= 0 ? cropr.images : cropr.documents;
      new collection.model({
        id: storageObjectId,
      }).fetch({
        success: function (doc) {
          successCallback(doc, collection);
        },
      });
    })
    .catch(function (error) {
      console.warn(error);
    });
};

export type PermissionObject = {
  create: boolean;
  update: boolean;
  delete: boolean;
  read: boolean;
  name: string;
  id: string;
};
